import React from "react"
import * as O from "fp-ts/Option"

export const Logo = () => (
  <svg viewBox="0 0 104 81">
    <use href="#flyp-logo"></use>{" "}
  </svg>
)

export const Close = () => (
  <svg viewBox="0 0 32 32">
    <use href="#flyp-close" />
  </svg>
)

export const Expand = ({ className }: { className: string }) => (
  <svg viewBox="0 0 21 21" className={className}>
    <use href="#flyp-expand" />
  </svg>
)

export const ChevronRight = () => (
  <svg viewBox="0 0 24 24">
    <use href="#flyp-chevron-right" />
  </svg>
)

export const ChevronLarge = () => (
  <svg viewBox="0 0 30 53">
    <use href="#flyp-chevron-large" />
  </svg>
)

export const CheckboxUnchecked = () => (
  <svg viewBox="0 0 17 18">
    <use href="#flyp-checkbox-unchecked" />
  </svg>
)
export const CheckboxChecked = () => (
  <svg viewBox="0 0 17 18">
    <use href="#flyp-checkbox-checked" />
  </svg>
)

export const Checkmark = () => (
  <svg viewBox="0 0 17 18">
    <use href="#flyp-checkmark" />
  </svg>
)

export const Account = ({ dataCy }: { dataCy: O.Option<string> }) => (
  <svg data-cy={O.toUndefined(dataCy)} viewBox="0 0 90 90">
    <use href="#flyp-account" />
  </svg>
)

export const Calendar = () => (
  <svg viewBox="0 0 333 126">
    <use href="#flyp-calendar" />
  </svg>
)

export const Stats = () => (
  <svg viewBox="0 0 45 45">
    <use href="#flyp-stats" />
  </svg>
)

export const ExternalLink = () => (
  <svg viewBox="0 0 18 18">
    <use href="#flyp-external" />
  </svg>
)

export const Cross = () => (
  <svg viewBox="0 0 8 8">
    <use href="#flyp-cross" />
  </svg>
)

export const ChatBuble = () => (
  <svg viewBox="0 0 76 76">
    <use href="#flyp-chat" />
  </svg>
)

export const Agent = () => (
  <svg viewBox="0 0 16 16">
    <use href="#flyp-agent" />
  </svg>
)

export const Clock = () => (
  <svg viewBox="0 0 16 16">
    <use href="#flyp-clock" />
  </svg>
)

export const House = () => (
  <svg viewBox="0 0 519 363">
    <use href="#flyp-house" />
  </svg>
)
